import { computed, shallowRef } from "vue";

import { getElement } from "~/services/dom";

export interface Address {
	street?: string;
	city?: string;
	zip_code?: string;
	country_code?: string;
	latitude?: number | string;
	longitude?: number | string;
}

export const form = shallowRef<Address | null>({
	street: "",
	city: "",
	zip_code: "",
	country_code: ""
});

export const isFormValid = computed(() => !!form.value && Object.values(form.value).some((value) => value !== ""));

export const isFormValidWithoutCountryCode = computed(() => {
	const { street, city, zip_code } = form.value!;
	return !!form.value && (street !== "" || city !== "" || zip_code !== "");
});

const billingFields = {
	address_1: '#billing-address_1, #billing_address_1, [name="billing_address_1"]',
	address_2: '#billing-address_2, #billing_address_2, [name="billing_address_2"]',
	city: '#billing-city, #billing_city, [name="billing_city"]',
	zipcode: '#billing-postcode, #billing_postcode, [name="billing_postcode"]',
	country: '#billing-country, #billing_country, [name="billing_country"]',
	state: '#billing-state, #billing_state, [name="billing_state"]'
};

const shippingFields = {
	address_1: '#shipping-address_1, #shipping_address_1, [name="shipping_address_1"]',
	address_2: '#shipping-address_2, #shipping_address_2, [name="shipping_address_2"]',
	city: '#shipping-city, #shipping_city, [name="shipping_city"]',
	zipcode: '#shipping-postcode, #shipping_postcode, [name="shipping_postcode"]',
	country: '#shipping-country, #shipping_country, [name="shipping_country"]',
	state: '#shipping-state, #shipping_state, [name="shipping_state"]'
};

const getBillingAddress = (): Address => ({
	street: getElement<HTMLInputElement>(billingFields.address_1 + ", " + billingFields.address_2, document)?.value.trim(),
	city: getElement<HTMLInputElement>(billingFields.city, document)?.value.trim(),
	zip_code: getElement<HTMLInputElement>(billingFields.zipcode, document)?.value.trim(),
	country_code: getElement<HTMLInputElement>(billingFields.country, document)?.value.trim()
});

const getShippingAddress = (): Address => ({
	street: getElement<HTMLInputElement>(shippingFields.address_1 + ", " + shippingFields.address_2, document)?.value.trim(),
	city: getElement<HTMLInputElement>(shippingFields.city, document)?.value.trim(),
	zip_code: getElement<HTMLInputElement>(shippingFields.zipcode, document)?.value.trim(),
	country_code: getElement<HTMLInputElement>(shippingFields.country, document)?.value.trim()
});

form.value = getBillingAddress();

const isShippingSelected = getElement<HTMLInputElement>(".wc-block-components-checkbox__input, #ship-to-different-address-checkbox, #checkbox-control-0", document);

const updateCurrentAddress = () => {
	form.value = isShippingSelected.checked ? getShippingAddress() : getBillingAddress();
	console.log(form.value);
};

isShippingSelected?.addEventListener("change", updateCurrentAddress);

Object.values(billingFields).forEach((field) => {
	const input = getElement<HTMLInputElement>(field, document);
	input?.addEventListener("input", updateCurrentAddress);
});

Object.values(shippingFields).forEach((field) => {
	const input = getElement<HTMLInputElement>(field, document);
	input?.addEventListener("input", updateCurrentAddress);
});
